import * as React from 'react';
export const shopifySvg = React.forwardRef(function shopifySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M23.594 8.993a.199.199 0 0 0-.19-.173c-.078 0-1.635-.031-1.635-.031s-1.306-1.258-1.431-1.4c-.126-.126-.378-.094-.472-.063l-.66.205a4.686 4.686 0 0 0-.316-.771c-.456-.881-1.148-1.353-1.966-1.353-.063 0-.11 0-.173.016-.031-.032-.047-.063-.078-.079a1.748 1.748 0 0 0-1.369-.55c-1.054.031-2.108.802-2.973 2.155-.597.96-1.053 2.155-1.195 3.082-1.211.378-2.06.645-2.092.645-.614.19-.63.205-.708.787-.031.44-1.636 12.85-1.636 12.85l13.465 2.329L26 25.195c-.015 0-2.39-16.091-2.406-16.202Zm-5.065-1.242c-.315.094-.66.204-1.038.33 0-.535-.08-1.29-.315-1.919.802.126 1.195 1.038 1.353 1.589Zm-1.746.535c-.708.22-1.479.456-2.25.692.22-.834.63-1.652 1.133-2.202.189-.205.456-.425.755-.551.315.613.378 1.479.362 2.06ZM15.336 5.5c.251 0 .456.048.629.173a2.788 2.788 0 0 0-.818.645c-.677.724-1.196 1.84-1.4 2.926-.645.205-1.274.393-1.84.566.377-1.714 1.809-4.262 3.429-4.31Z',
      fill: '#95BF47',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M23.405 8.82c-.079 0-1.636-.031-1.636-.031s-1.306-1.258-1.431-1.4a.253.253 0 0 0-.173-.079v19.332L26 25.195S23.625 9.103 23.61 8.993c-.032-.11-.127-.173-.205-.173Z',
      fill: '#5E8E3E',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm16.924 11.825-.676 2.532s-.755-.346-1.652-.283c-1.32.079-1.32.912-1.32 1.117.078 1.132 3.05 1.384 3.224 4.042.126 2.092-1.101 3.524-2.895 3.634-2.139.11-3.318-1.149-3.318-1.149l.456-1.934s1.195.896 2.139.833a.835.835 0 0 0 .818-.896c-.095-1.479-2.517-1.384-2.674-3.822-.126-2.045 1.211-4.106 4.168-4.295 1.148-.078 1.73.22 1.73.22Z',
      fill: '#fff',
    }),
  );
});
shopifySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var shopify = {
  category: 'brand',
  colorable: false,
  name: 'shopify',
  svg: shopifySvg,
};
